import { ICalendar } from '../models/ICalendar'

export const getCurrentValue = (value: ICalendar['value'], defaultMonth?: Date) => {
  const fallbackMonth = defaultMonth || new Date()

  if (value instanceof Date) {
    return value
  }
  if (value instanceof Array) {
    return value[0] || fallbackMonth
  }
  if (value?.from) {
    return value.from
  }
  if (value?.to) {
    return value.to
  }
  return fallbackMonth
}
